<template>
  <!-- :class="{ 'en-asibe': $i18n.locale != 'zh' }"
    :style="{ width: $i18n.locale == 'zh' ? '201px' : '280px' }" -->
  <el-aside :style="{ width: isCollapse ? '64px' : '280px' }" class="asibe">
    <el-menu
      class="menu"
      @open="handleOpen"
      @close="handleClose"
      background-color="#f3f3f3"
      text-color="#222222"
      active-text-color="#dcdcdc"
      :unique-opened="true"
      :default-openeds="openKeys"
      :default-active="$route.name"
      :collapse="isCollapse"
    >
      <div class="imgWrap">
        <img
          @click="isCollapse = !isCollapse"
          :src="require(isCollapse ? '../../assets/img/logoMini.png' : '../../assets/img/logo.png')"
          class="logo"
          alt="logo"
        />
      </div>
      <i
        class="change-icon"
        @click="isCollapse = !isCollapse"
        :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
      ></i>
      <template v-for="menu in headerLink">
        <el-menu-item
          class="home-item"
          @click="routerClick(menu.name, menu.title)"
          :index="menu.name"
          :key="menu.name"
          v-if="!menu.list || !menu.list.length"
        >
          <icon-svg v-if="menu.icon" :icon-class="menu.icon" />

          <router-link :to="{ name: menu.name }">
            <!--  menu.title  -->
            {{ getTitle(menu) }}
          </router-link>
        </el-menu-item>

        <el-submenu :index="menu.name" :key="menu.name" v-else>
          <template slot="title">
            <icon-svg v-if="menu.icon" :icon-class="menu.icon" />
            <span>{{ getTitle(menu) }}</span>
          </template>

          <template v-for="subMenu in menu.list">
            <el-menu-item
              @click="routerClick(subMenu.name, menu.title)"
              :key="subMenu.name"
              :index="subMenu.name"
            >
              <i v-if="subMenu.icon" :class="subMenu.icon"></i>
              <router-link :to="{ name: subMenu.name }">
                {{ getTitle(subMenu) }}
                <!-- {{ subMenu.title }} -->
              </router-link>
            </el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      openKeys: [],
      isCollapse: false
    }
  },
  computed: {
    headerLink() {
      const arr = JSON.parse(JSON.stringify(this.$store.state.headerLink))
      arr.unshift({
        icon: 'icondaohang_shouye',
        list: [],
        name: 'home',
        title: '首页'
      })
      return arr
    },
    currentPage() {
      return this.$store.state.currentPage
    }
  },
  created() {
    // this.openKeys = this.headerLink
    //   .find(item => item.id === this.currentPage)
    //   .filter(item => item.list && item.list.length)
    //   .map(item => item.key)
  },
  methods: {
    routerClick(name, title) {
      this.$router.push({ name })
    },
    getTitle(menu) {
      let item = menu.title
      return this.$t('basicsData.' + item)
    },
    handleOpen() {},
    handleClose() {}
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  background: #f3f3f3;
}
::v-deep .el-submenu__icon-arrow {
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  right: 30px;
}
.change-icon {
  font-size: 24px;
  // color: rgb(255, 255, 255);
  margin-bottom: 4px;
  position: absolute;
  right: 20px;
  top: 80px;
  cursor: pointer;
}
.asibe {
  display: flex;
  height: calc(100%);
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
  .svg-icon {
    width: 20px;
    height: 20px;
  }

  .menu {
    height: 100%;
    background: #f3f3f3;
    border-right: none;
  }
  ::v-deep .el-submenu {
    .el-menu-item {
      a {
        padding-left: 8px;
      }
    }
    .el-submenu__title span {
      margin-left: 10px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 120px;
      // font-size: 16px;
    }
    &.is-active {
      & > .el-submenu__title span {
        font-weight: bold;
      }
    }
  }
  .el-menu-item {
    a {
      color: #222222;
    }

    &:hover {
      background: #e6e6e6 !important;
      a {
        color: #222222;
      }
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: #ef2b23;
      }
    }
    &.is-active {
      background: #e6e6e6 !important;
      a {
        color: #ef2b23;
      }
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: #ef2b23;
      }
    }
  }

  .home-item {
    // display: flex;
    // align-items: center;
    // text-indent: 9px;

    // a {
    //   color: #222222;
    // }
    &.is-active {
      .svg-icon {
        color: #ef2b23;
      }
    }
  }
  .el-menu--collapse {
    .el-menu-item {
      a {
        display: none;
      }
      // &.is-active {
      //   a {
      //     color: #e6e6e6;
      //   }
      // }
    }
  }
}
.en-asibe {
  width: 280px;
}
.imgWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 33px 0 24px;
  .logo {
    height: 50px;
    vertical-align: middle;
    cursor: pointer;
  }
  .text {
    color: #ef2b23;
    font-size: 20px;
    font-weight: bold;
    margin-left: 10px;
  }
}
</style>
